<template>

  <div>
    <gmap-marker
      :key="index"
      v-for="(m, index) in getMarkers"
      :position="m.position"
      :visible="m.visibility"
      :icon="{ 
        url: require('../../assets/icons/pointServ.svg'),
        scaledSize: {width: 40, height: 60, f: 'px', b: 'px',},
      }"
      @click="toggleInfoWindow(m,index)">
    </gmap-marker>

    <gmap-info-window
      :options="infoOptions"
      :position="selectMarker"
      :opened="infoWinOpen"
      @closeclick="infoWinOpen=false"
    >
      <v-card
        class="overflow-y-auto elevation-0 mx-auto font-family"
       style="max-height: 200px; max-width: 320px !important;"
     >
        <v-card-text
          class="pt-4"
          style="position: relative;"
        >
          <div class="font-weight-bold subheading text-uppercase" style="color: #009640 !important; font-size: 16px;">
            {{point.NOMBRE_DIVISION}}</div>

          <v-divider style="background: ##ff0000 !important" class="my-2"></v-divider>
          <!-- <h3 class="display-1 font-weight-light orange--text mb-2">QW cooking utensils</h3> -->
          <div> 
            <b :style="validateTextColor">Dirección: </b> <span>{{point.DIRECCION_DIVISION}}</span>
          </div>
          <div>
            <b :style="validateTextColor">Código postal: </b> <span>{{point.CODIGO_POSTAL}}</span>
          </div>
          <div>
            <b :style="validateTextColor">Código postal ampliado: </b> <span>{{point.CODIGO_POSTAL_AMPLIADO}}</span>
          </div>
          <div>
            <b :style="validateTextColor">Ciudad: </b> <span>{{point.NOMBRE_CIUDAD}}</span>
          </div>
          <div>
            <b :style="validateTextColor">Departamento: </b> <span>{{point.NOMBRE_DEPARTAMENTO}}</span>
          </div>
          <div>
            <b :style="validateTextColor">Teléfono: </b> <span>{{point.NUMEROS_TELEFONO}}</span>
          </div>
          <div>
            <b :style="validateTextColor">Horario: </b> <span v-html="point.HORARIOS_ATENCION"></span>
          </div>

          <div class="mt-3">
            <v-btn
            @click="selectMode('DRIVING')"
            elevation="0"
            class="px-0 py-1 ml-4"
            style="min-width: min-content !important;"
          >
            <v-img  v-if="getTravelMode == 'DRIVING'" :width="40" src="../../assets/icons/car_active.svg"></v-img>
            <v-img  v-else :width="40" src="../../assets/icons/car.svg"></v-img>
          </v-btn>

          <v-btn
            @click="selectMode('TRANSIT')"
              elevation="0"
              class="px-0 py-1 ml-4"
              style="min-width: min-content !important;"
            >
              <v-img v-if="getTravelMode == 'TRANSIT'" :width="40" src="../../assets/icons/bus_active.svg"></v-img>
              <v-img v-else :width="40" src="../../assets/icons/bus.svg"></v-img>
          </v-btn>

          <v-btn
            @click="selectMode('WALKING')"
            elevation="0"
            class="px-0 py-1 ml-4"
            style="min-width: min-content !important;"
          >
            <v-img  v-if="getTravelMode == 'WALKING'" :width="40" src="../../assets/icons/walk_active.svg"></v-img>
            <v-img v-else :width="40" src="../../assets/icons/walk.svg"></v-img>
          </v-btn>

          </div>
        </v-card-text>
      </v-card>
    </gmap-info-window>
  </div>
  
</template>

<script>
import { mapGetters , mapActions } from 'vuex';
export default {
  name: "MarkerPoints",
  /* Componente de los marcadores de los puntos de atención */
  props: {
    infoOptions: Object
  }, 
  data() {
    return {
      infoWinOpen: false,
      travelMode: '',
      selectMarker: {},
      index: null,
      point: []
    };
  },
  computed: {
    ...mapGetters(['getMarkers', 'getPoints', 'getTravelMode']),
    validateTextColor() {
      return 'color: #310605;'
    }
  },
  methods: {
    ...mapActions(['addTravelMode', 'selectCard', 'addMarketSelect']),
    toggleInfoWindow: function (marker, idx) {

      this.selectMarker = marker.position;
      /* for(let i = 0; i < this.markers.length; i++){
        this.markers[i].select = false
      }
      this.markers[idx].select = true */

      this.point = this.getPoints[idx];
      this.addMarketSelect(marker.position);
      this.index = idx;

      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      }
      else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    selectMode(mode,) {
      this.addTravelMode(mode);
      this.selectCard(this.index);
      location.href = '#card-'+this.index
      this.$emit('onGenerateRoute', mode);
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css?family=Montserrat:wght@500');

.font-family{
  font-family: 'Montserrat';
}

.v-btn:not(.v-btn--round).v-size--large {
  padding: 3px 9px !important;
}
</style>